export function StatCard({ label, value, accent, icon: Icon, testid, sub, onClick }) {
  return (
    <div
      data-testid={testid}
      onClick={onClick}
      className={`bg-card border border-border rounded-sm p-4 flex flex-col justify-between h-full transition-colors hover:border-[#3f3f46] ${onClick ? "cursor-pointer" : ""}`}
    >
      <div className="flex items-start justify-between">
        <span className="label-caps">{label}</span>
        {Icon && <Icon size={18} weight="bold" style={{ color: accent || "#71717A" }} />}
      </div>
      <div className="mt-3 font-display font-black text-3xl lg:text-4xl leading-none"
           style={{ color: accent || "#fff" }}>
        {value}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
